import { StatusBar } from "expo-status-bar";
import React, { useState } from "react";
import { LogBox, StyleSheet, Text, View } from "react-native";
import Routes from "./src/routes";
import AppLoading from "expo-app-loading";
import * as Font from "expo-font";
import { useEffect } from "react";
import * as SplashScreen from "expo-splash-screen";
import { RecoilRoot } from "recoil";
import { height, width } from "./src/utils/utils";
export default function App() {
  const [fontsLoaded, setFont] = useState(false);
  const [dimensions, setDimensions] = useState({
    width: width,
    height: height,
  });

  const backup = console.warn;

  console.warn = function filterWarnings(msg) {
    const supressedWarnings = ["Warning:", "other warning text"];

    if (!supressedWarnings.some((entry) => msg.includes(entry))) {
      backup.apply(console, arguments);
    }
  };

  console.warn("I'll appear as a warning");

  console.warn("warning text - I will not");

  function debounce(fn, ms) {
    let timer;
    return (_) => {
      clearTimeout(timer);
      timer = setTimeout((_) => {
        timer = null;
        fn.apply(this, arguments);
      }, ms);
    };
  }

  React.useEffect(() => {
    const debouncedHandleResize = debounce(function handleResize() {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth,
      });
    }, 1000);

    window.addEventListener("resize", debouncedHandleResize);

    return (_) => {
      window.removeEventListener("resize", debouncedHandleResize);
    };
  });

  useEffect(() => {
    loadFonts();
    SplashScreen.hideAsync();
  }, []);

  async function loadFonts() {
    await Font.loadAsync({
      Prompt: require("./assets/fonts/Prompt-Regular.ttf"),
      Segoe: require("./assets/fonts/segoe-ui.ttf"),
    });
    setFont(true);
  }

  if (!fontsLoaded) {
    return <AppLoading />;
  } else {
    return (
      <View
        style={[
          styles.container,
          {
            width: dimensions.width,
            height: dimensions.height,
            overflow: "hidden",
          },
        ]}
      >
        <RecoilRoot>
          <Routes />
          <View
            style={{
              width: "100%",
              borderWidth: 1,
              borderColor: "#2D69AE",
              height: 40,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Text
              style={{ fontFamily: "Prompt", fontSize: 13, color: "#2D69AE" }}
            >
              copyright © AAA
            </Text>
          </View>
        </RecoilRoot>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    width: "100%",
    height: "100%",
    backgroundColor: "#fff",
  },
});
